import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../../../app/core/shared-service/grid-utils';

class ProcessDelayCtrl {
    /*@ngInject*/
    constructor(
        $translate,
        uiGridConstants,
        BATCH_PROCESS_DELAY_STATUS,
        ProcessDelayFilter,
        ProcessDelayService,
        LadProviderService,
        DateService,
        dateFilter,
        ProcessDelay
    ) {
        this.$translate = $translate;
        this.uiGridConstants = uiGridConstants;
        this.BATCH_PROCESS_DELAY_STATUS = BATCH_PROCESS_DELAY_STATUS;
        this.ProcessDelayFilter = ProcessDelayFilter;
        this.ProcessDelayService = ProcessDelayService;
        this.LadProviderService = LadProviderService;
        this.DateService = DateService;
        this.dateFilter = dateFilter;
        this.ProcessDelay = ProcessDelay;
    }

    $onInit() {
        let vm = this;

        vm.selected = {};

        // ----------------------------
        // Data API
        // ----------------------------

        // Init des données
        vm.statusList = vm.BATCH_PROCESS_DELAY_STATUS;

        vm.ladProviders = vm.LadProviderService.findAll();
        vm.getTableHeight = getTableHeight;
        vm.listCompanies = listCompanies;
        vm.canExportGridCsv = canExportGridCsv;
        vm.exportGridCsv = exportGridCsv;
        vm.onPrincipalChanged = onPrincipalChanged;

        // Recherche
        vm.searchData = new vm.ProcessDelayFilter();

        // ----------------------------
        // Function API
        // ----------------------------
        // Export CSV
        vm.search = search;
        vm.clearForm = clearForm;

        var defaultCellTemplate =
            '<div class="ui-grid-cell-contents ui-grid-cursor-default">{{COL_FIELD CUSTOM_FILTERS}}</div>';

        // Liste
        vm.gridOptions = {
            columnDefs: [
                {
                    name: 'batchId',
                    displayName: 'dashboard.column.batch.batch.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'dashboard.column.envelope.status',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: 'translate',
                },
                {
                    name: 'sentDate',
                    displayName: 'dashboard.column.batch.ladSentDate',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'short'",
                },
                {
                    name: 'processedDate',
                    displayName: 'dashboard.column.batch.processedDate',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'short'",
                    sort: {
                        direction: vm.uiGridConstants.DESC,
                        priority: 0,
                    },
                },
                {
                    name: 'principalName',
                    displayName: 'dashboard.column.envelope.principal',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'companyName',
                    displayName: 'dashboard.column.envelope.company.name',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'containerId',
                    displayName: 'dashboard.column.envelope.container.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'ladProviderName',
                    displayName: 'dashboard.column.batch.ladProvider',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'ladProcessedDelay',
                    displayName: 'dashboard.column.batch.processDelay',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'text-right',
                    cellFilter: 'number',
                    headerCellFilter: 'translate',
                },
            ],
            useExternalPagination: false,
            useExternalSorting: false,
            enableSorting: true,
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            enableColumnMenus: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            enableVerticalScrollbar: vm.uiGridConstants.scrollbars.NEVER,
            exporterHeaderFilter: vm.$translate.instant,
            exporterFieldCallback: function (grid, row, col, value) {
                if (col.name === 'processedDate' || col.name === 'sentDate') {
                    value = vm.dateFilter(value, 'short');
                }
                return value;
            },
            gridMenuTitleFilter: vm.$translate,
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
            },
        };

        function search() {
            vm.preparedSearchFilter = vm.searchData.preparBeforeSearch(vm.selected.company);
            vm.processDelayPromise = vm.ProcessDelayService.search(vm.preparedSearchFilter).$promise;
            vm.processDelayPromise.then(function (result) {
                vm.gridOptions.data = _.map(result, function (processDelayData) {
                    return new vm.ProcessDelay(processDelayData);
                });
            });
        }

        function clearForm() {
            // Reset data
            vm.searchData = new vm.ProcessDelayFilter();
            // Recherche
            vm.search();
            // Reset form
            vm.form.$setPristine();
        }

        // Liste les sociétés disponibles en fonction du DO sélectionné
        function listCompanies() {
            var filteredCompanies = [];
            angular.forEach(vm.companies, function (value) {
                if (!vm.searchData.principalId || value.principalId === vm.searchData.principalId) {
                    filteredCompanies.push(value);
                }
            });
            return filteredCompanies;
        }

        // Indique si l'export CSV de la grille peut être réalisé
        function canExportGridCsv() {
            if (!(vm.gridApi === undefined || vm.gridApi.selection === undefined)) {
                return vm.gridApi.selection.getSelectedRows().length > 0;
            }
            return false;
        }

        // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
        function exportGridCsv() {
            // Nom du fichier CSV : epdf_DateHeure_dataDelai.csv
            var now = new Date();
            var filename = 'epdf_' + vm.DateService.formatAsYMD_HM(now) + '_dataDelai.csv';
            vm.gridOptions.exporterCsvFilename = filename;

            var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
            vm.gridApi.exporter.csvExport('selected', 'all', myElement);
        }

        function onPrincipalChanged() {
            vm.searchData.companyName = null;
        }

        function getTableHeight() {
            return gridHeight(vm.gridApi);
        }
    }
}

angular.module('processdelay').component('processdelay', {
    templateUrl: require('./process-delay.html'),
    controller: ProcessDelayCtrl,
});
